export class LocaleElement {
  keyCode;
  allowForAllLocales;
  defaultTextData;

  constructor() {
    this.keyCode = '';
    this.allowForAllLocales = true;
    this.defaultTextData = '';
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/locales/locale-element.model.ts